<template>
  <div
    class="margin-property-details"
    v-if="form.propertyDetailsFormVisibility"
  >
    <!-- Lexis Nexis error -->
    <v-alert
      dense
      text
      type="error"
      icon="mdi-alert-circle"
      class="margin-property-details-alert mb-5 warning-text"
      v-if="userMustFill"
      ><span v-if="!question.WarningText" class="black--text"
        >Sorry we are <strong>not</strong> able to get your property details at
        this time. Please add your property details below.</span
      >
      <span v-else class="black--text" v-html="question.WarningText"></span
    ></v-alert>
    <!-- Property Details questions -->
    <template v-for="(item, index) in question.Questions">
      <v-row
        :key="index"
        :class="[
          item.AnswerControlType === 'CounterBase' ? 'margin-hide-details' : '',
          'mt-0',
        ]"
      >
        <v-col>
          <component :is="item.AnswerControlType" :question="item"></component>

          <template v-if="item.DataUiid === 'NumberOfBathrooms'">
            <v-alert color="var(--blue-100)" class="mt-4 mb-0 note-warning">
              <div class="d-flex flex-no-wrap">
                <div class="mr-3">
                  <v-icon>icon-bath</v-icon>
                </div>
                <div>
                  <span class="font-weight-bold">Note:</span>&nbsp;Bathrooms
                  include en-suites, wetrooms, toilet rooms and shower rooms,
                  the number above should include these.
                </div>
              </div>
            </v-alert>
          </template>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import CounterBase from "@/components/Counters/CounterBase";
import InputBase from "@/components/Inputs/InputBase";
import RadioImageBase from "@/components/Radios/RadioImageBase";
import SelectBase from "@/components/Selects/SelectBase";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapGetters, mapState } from "vuex";

export default {
  name: "LayoutPropertyDetails",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  components: {
    CounterBase,
    InputBase,
    RadioImageBase,
    SelectBase,
  },
  computed: {
    ...mapState(QUESTIONS_MODULE, ["form"]),
    ...mapGetters(QUESTIONS_MODULE, ["propertyDataRequiresEdit"]),
    userMustFill() {
      // Shows the alert message if LN lookup failed
      return (
        this.form.propertyDetailsFormVisibility &&
        this.propertyDataRequiresEdit &&
        this.form.isLNErrorMessageEnabled
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-property-details {
  margin: 0px 0 20px 0;
}

.margin-property-details-alert {
  margin: 26px 0 0 0;
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .warning-text {
    width: 900px !important;
  }
}
</style>
